import { defineStore } from 'pinia';
import { ref } from 'vue';

import { Status } from '../models/Common/CommonModels';

const defaultLagerortid = '102';

export const useEwwmsCommonStore = defineStore('ewwmsCommonStore', () => {
  const status = ref<Status>(new Status());
  const lagerortid = ref<string>(localStorage.getItem('lagerortid') != null ? JSON.parse(localStorage.getItem('lagerortid')!) : defaultLagerortid);

  function setStatus(newStatus: Status): void {
    status.value = newStatus;
  }

  function setLagerortid(newLagerortid: string): void {
    lagerortid.value = newLagerortid;
    localStorage.setItem('lagerortid', JSON.stringify(lagerortid.value));
  }

  function toggleSidebar(): void {
    status.value.sidebarCollapsed = !status.value.sidebarCollapsed;
  }

  return {
    status,
    lagerortid,
    setStatus,
    setLagerortid,
    toggleSidebar,
  };
});
